import { FormInputController } from '@ciam/form-kit';
import { useTranslation } from '@ciam/i18n';
import { Button, ErrorMessage, PasswordField } from '@ciam/ui';
import { useSetAccountPasswordForm } from '@features/proxy';
import { AuthForm } from '@features/shared';

export const SetAccountPasswordForm = () => {
  const { t } = useTranslation(['proxy', 'schemas']);
  const {
    control,
    onSubmit,
    formState: { errors, isValid },
  } = useSetAccountPasswordForm();

  return (
    <AuthForm onSubmit={onSubmit} style={{}}>
      <FormInputController
        id="currentPassword"
        name="currentPassword"
        component={PasswordField}
        label={t('reset-password-modal.form.fields.current-password.label')}
        placeholder={t('reset-password-modal.form.fields.current-password.placeholder')}
        control={control}
        errors={errors}
      />
      <FormInputController
        id="newPassword"
        name="newPassword"
        component={PasswordField}
        label={t('reset-password-modal.form.fields.new-password.label')}
        placeholder={t('reset-password-modal.form.fields.new-password.placeholder')}
        control={control}
        errors={errors}
      />
      <FormInputController
        id="newPasswordConfirm"
        name="newPasswordConfirm"
        component={PasswordField}
        label={t('reset-password-modal.form.fields.new-password-confirm.label')}
        placeholder={t('reset-password-modal.form.fields.new-password-confirm.placeholder')}
        control={control}
        errors={errors}
      />
      <ErrorMessage message={errors.root?.message} />
      <Button type="submit" size="m" buttonTheme={isValid ? 'blue' : 'white'} disabled={!isValid}>
        {t('reset-password-modal.form.submit-button')}
      </Button>
    </AuthForm>
  );
};
